import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import ServiceManager from '../../components/account/ServiceManager';

const ServiceManage = ({ account, dispatch, intl }) => {
  return <ServiceManager {...account} intl={intl} dispatch={dispatch} />;
};

const mapStateToProps = state => {
  return Object.assign({}, state, { loading: state.loading.global });
};

export default connect(mapStateToProps)(injectIntl(ServiceManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/ServiceManage.js